import { render } from "./MenuProduction.vue?vue&type=template&id=bdfaddc2&scoped=true"
import script from "./MenuProduction.vue?vue&type=script&lang=js"
export * from "./MenuProduction.vue?vue&type=script&lang=js"

import "./MenuProduction.vue?vue&type=style&index=0&id=bdfaddc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdfaddc2"]])

export default __exports__